export const NONE = 'none'
export const TOOLTIP = 'tooltip'
export const DROP = 'drop'
